import {API_URL} from "../../components/config/BaseUrl";

// eslint-disable-next-line import/prefer-default-export
export const GET_IVRS_URL = `${API_URL}/ivr/getivr`;
